"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsMapManager", function() {
    return {
        restrict     : "A",
        controllerAs : "mapManagerCtrl",
        scope        : true,
        link         : function($scope, $el, $attrs, ctrl) {
            ctrl.initialize();
        },
        controller : function($scope) {

            var ctrl     = this;

            ctrl.initialize = function() {
            };

            ctrl.setViewport = function(_viewport) {
                $scope.viewport = _viewport;
            };

            ctrl.getViewport = function() {
                return $scope.viewport;
            };

        }
    };
});


// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/common/obsMapManager.js